export interface GenerateFileResponse {
    statusCode: number;
    message: string;
}

import { saveAs } from 'file-saver';

export async function downloadFile(
    token: string,
    selectedUnidade: string,
    url: string,
    filename: string,
): Promise<GenerateFileResponse> {
    const requestHeaders: HeadersInit = new Headers();
    requestHeaders.append('Authorization', `Bearer ${token}`);
    requestHeaders.append('quickcomexTenant', selectedUnidade);

    const response = await fetch(url, {
        method: 'GET',
        headers: requestHeaders,
    });

    if (!response.ok) {
        try {
            const data = await response.json();
            const message: string = data.message || 'Erro desconhecido ao gerar o arquivo.';

            return { statusCode: response.status, message: `Erro no download: ${message}` };
        } catch(error) {
            return { statusCode: response.status, message: `Erro ${response.status}: Falha ao gerar o arquivo. Tente novamente.`};
        }
    }

    const blob = await response.blob();

    saveAs(blob, `${filename}`); 
  
  return { statusCode: 200, message: `Arquivo "${filename}" gerado e download iniciado com sucesso!` };
}

const TsTechPageHelpers = {
  downloadFile,
};

export default TsTechPageHelpers;